export function optional(f) {
  return f == null ? null : required(f);
}

export function required(f) {
  if (typeof f !== "function") throw new Error;
  return f;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-hierarchy/src/accessors.js
// module id = 0r/C
// module chunks = 0